import { Box, Grid } from "@material-ui/core";
import { DATE_FORMAT_PRINT } from "config/constants";
import useText from "constants/text";
import NTCollipsableStops from "domains/Request/component/NationalTransport/Collapse";
import ParcelCard from "domains/Request/component/ParcelCard";
import CollipsableAddress from "domains/Request/component/SamaPapser/CollipsableAddress";
import { ERequestType } from "generated/graphql";
import { CalendarsIcon, ProductTypeIcon } from "icons";
import moment from "moment";
import { renderReccurenceOption } from "../../RenderOptions";
import { useDetailsStyles } from "../../RightSideDetails";
import ParcelCardDate from "domains/Request/component/ParcelCardDate";

interface SchedulingDetailsProps {
  requestToDisplay?: any;
  isDisabled?: boolean;
}

const SchedulingDetails = ({ requestToDisplay, isDisabled = false }: SchedulingDetailsProps) => {
  const { text } = useText();
  const styles = useDetailsStyles();

  
  return (
    <>
      <Box className={styles.details}>
        {text.all.scheduling} <hr className={styles.hr} />
      </Box>
     
        <Grid item xs={12}>
          <CollipsableAddress requestQuote={requestToDisplay} />
        </Grid>
      

      <Grid className={styles.parcelCardGrid}>
        <Box className={styles.marge}>
          <ParcelCard icon={<ProductTypeIcon />} title="Product type" value={requestToDisplay?.productType} />
        </Box>
        {!isDisabled && (
          <Box className={styles.marge}>
            <ParcelCard
              icon={<CalendarsIcon />}
              title="Recurrence"
              value={renderReccurenceOption(requestToDisplay, text)}
            />
          </Box>
        )}
        <Box className={styles.marge}>
          <ParcelCardDate
            icon={<CalendarsIcon />}
            title="Start Date"
            value={moment(requestToDisplay?.startDate).format(DATE_FORMAT_PRINT)}
          />
        </Box>
        <Box className={styles.marge}>
          {requestToDisplay?.endDate && (
            <ParcelCardDate
              icon={<CalendarsIcon />}
              title="End Date"
              value={moment(requestToDisplay?.endDate).format(DATE_FORMAT_PRINT)}
            />
          )}
        </Box>
      </Grid>
    </>
  );
};

export default SchedulingDetails;
